import { ApiRequestContextData } from "@utils/api-config/types";

export function getShopUserRequestContext() {
	const user = App.state.rootStore.userAuthStore.shopUser;
	if (!user) {
		return null;
	}
	const token = App.state.rootStore.userAuthStore.shopUserToken;

	if (!token) {
		return null;
	}
	const requestMetaData: ApiRequestContextData = {
		agencyId: user.agencyId,
		agencyKey: user.agencyKey,
		authToken: token,
		shopId: user.shopId,
		userId: user.id,
		username: user.username,
	};

	return requestMetaData;
}
